import {
  FormProps,
  InputDescription,
  InputFileUpload,
  InputName,
} from "@components-common/forms";
import { FC, useEffect, useState } from "react";
import { MediaItemInputByType } from "../media-library/components/MediaItemInputByType";
import { useFormikContext } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Loader } from "taltech-styleguide";
import { application } from "../../../_runtime/bootstrap";
import { useNotifications } from "@hooks";
import { isEmpty } from "ramda";

const ResourcesFormContent = ({ onFileChange }: any) => (
  <Col xs="12" md="6" className="d-flex flex-column gap-3">
    <InputName elementClass="required" />
    <InputDescription />
    <InputFileUpload
      type="FILE"
      handleFileFromOutside={true}
      setFile={onFileChange}
    />
    {/* Leave this comment commented as I am not sure if it should be this way to upload resources */}
    {/* <MediaItemInputByType {...props} /> */}
  </Col>
);

export const ResourcesForm: FC<FormProps<any>> = (props) => {
  const nav = useNavigate();
  const userNotifications = useNotifications();
  const formik = useFormikContext();
  const { id, assignmentId } = useParams();
  const [file, setFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const validateForm = async () => {
    return await formik.validateForm();
  };

  useEffect(() => {
    if (formik.isSubmitting) {
      const promiseValidation = validateForm();
      promiseValidation.then((res) => {
        if (isEmpty(res)) {
          setIsLoading(true);
          const values: any = formik.values;
          const subjectId: string = assignmentId
            ? assignmentId
            : (id as string);
          var formData = new FormData();
          formData.append("Name", values.name);
          formData.append("Description", values.description);
          formData.append("Type", "FILE");
          formData.append("SubjectId", subjectId);
          formData.append("Source", "Course");

          if (file) {
            formData.append("File", file);
            formData.append("FileName", file!.name);
          } else {
            userNotifications.error({ title: "You need to upload a file." });
            return;
          }

          application
            .getHttpClient()
            .post("/mediasms/mediaitemresources/postWithStreaming", formData, {
              headers: {
                " Content-Type": "multipart/form-data",
              },
            })
            .then(() => nav(-1))
            .finally(() => {
              setIsLoading(false);
              formik.setSubmitting(false);
            });
        } else formik.setSubmitting(false);
      });
    }
  }, [formik.isSubmitting]);
  return isLoading ? (
    <Loader fullScreen />
  ) : (
    <ResourcesFormContent onFileChange={setFile} />
  );
};
